// i need a theme that will make backgrounds orange, will make letters more stylish and will make the buttons more stylish

import { createTheme } from '@mui/material/styles';

const alternateTheme = createTheme({
  palette: {
    primary: {
      main: '#FF8C00', // Dark orange
      light: '#FFB74D',
      dark: '#E67E22', // Slightly darker orange for better contrast
      contrastText: '#FFF',
    },
    secondary: {
      main: '#2C3E50', // Dark blue-grey for professional accent
      light: '#34495E',
      dark: '#2C3E50',
      contrastText: '#FFF',
    },
    background: {
      default: '#F8F9FA', // Light grey background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C3E50', // Dark blue-grey for text
      secondary: '#5D6D7E', // Lighter blue-grey for secondary text
      light: '#FFFFFF',
    }
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Arial', sans-serif", // Using Inter for more modern look
    h1: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      color: '#2C3E50',
    },
    h2: {
      fontWeight: 700,
      letterSpacing: '-0.01em',
      color: '#2C3E50',
    },
    h3: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
      color: '#2C3E50',
    },
    h4: {
      fontWeight: 600,
      letterSpacing: 0,
      color: '#2C3E50',
    },
    h5: {
      fontWeight: 600,
      color: '#2C3E50',
    },
    h6: {
      fontWeight: 600,
      color: '#2C3E50',
    },
    button: {
      fontWeight: 600,
      letterSpacing: '0.02em',
      textTransform: 'none',
    },
    body1: {
      fontSize: '1rem',
      letterSpacing: '0.01em',
      
    },
    body2: {
      fontSize: '0.875rem',
      letterSpacing: '0.01em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          padding: '8px 20px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          },
        },
        contained: {
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.08)',
          '&:hover': {
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.12)',
          },
        },
        outlined: {
          borderWidth: '1.5px',
          '&:hover': {
            borderWidth: '1.5px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
        elevation1: {
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
        },
        elevation2: {
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#E67E22', // Slightly darker orange than primary for better readability
          textDecoration: 'none', // Start without underline
          fontWeight: 500, // Slightly bolder than normal text
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            color: '#D35400', // Darker shade on hover
            textDecoration: 'underline', // Add underline on hover
            textUnderlineOffset: '2px', // Space between text and underline
          },
          '&:active': {
            color: '#BA4A00', // Even darker when clicked
          },
          '&:visited': {
            color: '#E67E22', // Keep same color even after visited
          }
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
          },
        },
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export default alternateTheme;
    